import ReceptionAppointment from "./ReceptionAppointment";

export default ReceptionAppointment;